import React, {useContext, useEffect, useState} from 'react';
import {Button, Col, ConfigProvider, Form, Input, Modal, Row, Select, Table, InputNumber, Spin} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import {GetEscoles} from "../../../dao/root/GetEscoles";
import { PostProposta } from '../../../dao/menudesign/comandes/PostProposta';
import {AuthContext} from "../../../config/AuthContext";
import Proposta from "../../../model/menudesign/comandes/Proposta";
import {ColumnsType, TableProps} from "antd/es/table";
import {GetComandaId} from "../../../dao/menudesign/comandes/GetComandaId";
import dayjs from "dayjs";
import Ingredient from '../../../model/menudesign/Ingredient';
import { GetComandaAfegitId } from '../../../dao/menudesign/comandes/GetComandaAfegitId';
import { PostComandaIngredient } from '../../../dao/menudesign/comandes/PostComandaIngredient';
import {useNavigate, useParams} from "react-router-dom";



const {TextArea} = Input;
const {Option} = Select;

interface PropostatModalProps {
    element: string;
    visible: boolean;
    onClose: (value: boolean) => void;
    editar?: boolean;
}

const ComandaPerEnviarModal: React.FC<PropostatModalProps> = ({element, visible, onClose, editar}) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const [coleccio, setDades] = useState<any[]>([]);
    const [comanda, setComanda] = useState<any>({});
    const [coleccioAltres, setDadesAltres] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const esSuperusuari = user?.rol?.some((rol: any) => rol.nom === "superusuari");
    

   useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [isLoggedIn]);

    async function handleSubmit() {
        try {
            setLoading(true);

            const agrupats: Record<string, any[]> = {};
            comanda?.plats?.forEach((plat: any) => {
            plat.ingredients?.forEach((ing: any) => {
                const dia = plat.data || null;
                const key = `${ing.id}_${dia}`;
                if (!agrupats[key]) agrupats[key] = [];
                agrupats[key].push({
                id_ingredient: ing.id,
                nom: ing.nom,
                quantitat: ing.total || 0,
                mesura: ing.mesura,
                dia,
                afegit: ing.modificacio || 0,
                });
            });
            });

            const totalsPerDia: any[] = Object.entries(agrupats).map(([key, arr]) => {
            const base = arr[0];
            const quantitatTotal = arr.reduce((acc, i) => acc + (i.quantitat || 0), 0);
            const afegitTotal = arr.reduce((acc, i) => acc + (i.afegit || 0), 0);
            return {
                id_ingredient: base.id_ingredient,
                nom: base.nom,
                quantitat: quantitatTotal,
                dia: base.dia,
                afegit: afegitTotal,
                mesura: base.mesura,
            };
            });

            const perIngredient = totalsPerDia.reduce((acc: any, item) => {
            if (!acc[item.id_ingredient]) acc[item.id_ingredient] = [];
            acc[item.id_ingredient].push(item);
            return acc;
            }, {});

            const ajustats: any[] = [];
            Object.values(perIngredient as Record<string, any[]>).forEach((items) => {
            const totalAfegit = items.reduce((acc, i) => acc + i.afegit, 0);
            const parts = items.length;
            const afegitPerPart = parts > 0 ? totalAfegit / parts : 0;

            items.forEach((i) => {
                ajustats.push({
                id_ingredient: i.id_ingredient,
                quantitat: i.quantitat + afegitPerPart,
                dia: i.dia,
                afegit: 0, 
                });
            });
            });

            const altres = coleccioAltres.map((item) => ({
            id_ingredient: item.id_ingredient,
            quantitat: item.variacio || 0,
            dia: item.dia ? dayjs(item.dia).format("YYYY-MM-DD") : null,
            afegit: 1,
            }));

            const resultatFinal = [...ajustats, ...altres];

           
            await PostComandaIngredient(page, resultatFinal, Number(element), userId);

            Modal.success({
            title: "Comanda finalitzada correctament",
            });

            onClose(true);
            navigate(`/menudesign/propostes`);
        } catch (error) {
            console.error("Error al finalizar comanda:", error);
            Modal.error({ title: "Error al finalizar la comanda" });
        } finally {
            setLoading(false);
        }
        }

    async function checkDades() {
        try {
            setLoading(true);
            const dades = await GetComandaId(page, element + "");
            setComanda(dades);
            if (!dades) {
                setDades([]);
                return;
            }

            const plats = Array.isArray(dades.plats) ? dades.plats : [];
            if (plats.length === 0) {
                console.warn(" GetComandaId no contiene 'plats' o está vacío:", dades);
            }

           
            const totsIngredients = plats.flatMap((p: any) =>
            (p.ingredients || []).map((ing: any) => ({
                id: ing.id,
                nom: ing.nom,
                mesura: ing.mesura,
                total: ing.total || 0,
                afegit: ing.modificacio || 0,
                totalFinal: (ing.total || 0) + (ing.modificacio || 0),
            }))
            );

            
            const agregats = Object.values(
            totsIngredients.reduce((acc: any, ing: any) => {
                if (!acc[ing.id]) {
                    acc[ing.id] = { ...ing };
                } else {
                    acc[ing.id].total += ing.total;
                    acc[ing.id].afegit += ing.afegit;
                    acc[ing.id].totalFinal += ing.totalFinal;
                }
                return acc;
            }, {})
            );

            
            setDades(agregats);
            const dadesAfegit = await GetComandaAfegitId(page, Number(element));
            if (dadesAfegit?.length > 0) {
                const dadesTransformades = dadesAfegit.map((item: any) => ({
                    nom: item.nom,
                    id_ingredient: item.id_ingredient,
                    variacio: item.variacio,
                    dia: item.dia ? dayjs(item.dia, "YYYY-MM-DD") : null,
                    mesura: item.mesura,
                }));
                setDadesAltres(dadesTransformades);
                    
            }

        } catch (error) {
            console.error("Error en checkDades:", error);
            setDades([]);
        } finally {
            setLoading(false);
        }
    }

    const handleCancel = () => {
        onClose(false);
    };
    const tableProps: TableProps<Ingredient> = {
        loading
    };

    const onChange: TableProps<Ingredient>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
    };

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'ID'
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Ingredient'
        },
        {
            key: 'totalFinal',
            dataIndex: 'totalFinal',
            title: 'Total',
            render: (_, ele) => (
                            <InputNumber disabled value={ele.total} min={0} step={0.1} addonAfter={ele.mesura}/>
                        )
        },
        {
            key: 'accions', dataIndex: 'accions',
            title: 'Afegir',
            render: (estat, ele) => (
                <InputNumber style={{backgroundColor: Colors.colors.color6}}
                             defaultValue={0.0} step={0.1}  addonAfter={ele.mesura} addonBefore="+"/>
            )
        },
        
        
    ];
    const columnsAltres: ColumnsType<any> = [
        {
            key: 'id_ingredient',
            dataIndex: 'id_ingredient',
            title: 'ID'
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Ingredient'
        },
        {
            key: 'variacio',
            dataIndex: 'variacio',
            title: 'Total',
            render: (_, ele) => (
                            <InputNumber disabled value={ele.variacio} min={0} step={0.1} addonAfter={ele.mesura}/>
                        )
        },
        {
            key: 'accions', dataIndex: 'accions',
            title: 'Afegir',
            render: (estat, ele) => (
                <InputNumber style={{backgroundColor: Colors.colors.color6}}
                             defaultValue={0.0} step={0.1}  addonAfter={ele.mesura} addonBefore="+"/>
            )
        },
        
        
    ];

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="Resum de la comanda"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={600}
        >
            <Form form={form} onFinish={handleSubmit} >
                
                <hr/>
                <Spin spinning={loading}>
                   <Table
                        {...tableProps}
                        onChange={onChange}
                        columns={columns}
                        pagination={{pageSize: 5}}
                        dataSource={coleccio}
                    />
                </Spin> 
                <h6>Altres ingredients</h6>
                <Spin spinning={loading}>
                    <Table
                        {...tableProps}
                        onChange={onChange}
                        columns={columnsAltres}
                        pagination={{pageSize: 5}}
                        dataSource={coleccioAltres}
                   />
                </Spin>       
                
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default ComandaPerEnviarModal;
